import { BehaviorSubject, Observable } from 'rxjs';

/**
 * An observable bit of state dedicated and it's accessors. Dedicated to information about a particular loader's status.
 * `true` means there's activity on the channel and it's currently loading.
 */
export class LoaderChannel {
    /** @ignore The subject that keeps track of the channel's current state. */
    private _status: BehaviorSubject<boolean>;
    /** @ignore Not used. This was going to be a way to customize a channel setter, but we've ended up going with subscriptions for the moment. */
    _setterCallback;
    /** @ignore Initialize the channel's behaviorSubject. */
    constructor (initialValue: boolean, setterCallback = () => {}) {
        this._status = new BehaviorSubject(initialValue);
        this._setterCallback = setterCallback;
    }
    /** Update the channel's activity status. */
    public set setStatus (status: boolean) {
        this._setterCallback();
        this._status.next(status);
    }
    /** Get an observable of the channel's activity. */
    public get getStatus (): Observable<boolean> {
        return this._status.asObservable();
    }
}
